export const currentYear = new Date().getFullYear();

export const listOfMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const currentMonthName: string = (() => {
  const currentDate = new Date();
  const monthNumber = currentDate.getMonth();

  return listOfMonths[monthNumber];
})();
